import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Paper from '@base/Paper/Paper';
import H2 from '@base/H2/H2';
import Image from '@base/Image';
import { breakpoints, Spacings } from '@styles/index';

const StyledPaper = styled(Paper)`
  display: flex;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    box-shadow: none;
    background-color: var(--color-base-0);
    padding: ${Spacings.SPACING_6B} 0;
  }
`;

const GoalImage = styled.div`
  position: relative;
  height: 64px;
  width: 64px;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 36px;
    height: 32px;
  }
`;

const StyH2 = styled(H2)`
  margin: 0 0 0 ${Spacings.SPACING_10B};
  align-self: center;
  color: var(--color-text-primary);
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin-left: ${Spacings.SPACING_4B};
  }
`;
const TopBlock = ({ goalIcon, goalName, className }) => {
  return (
    <StyledPaper
      className={className}
      gridColumn="span 18"
      padding={`${Spacings.SPACING_10B} ${Spacings.SPACING_12B}`}
    >
      <GoalImage>
        <Image src={goalIcon} alt={goalName} layout="fill" />
      </GoalImage>
      <StyH2>{goalName}</StyH2>
    </StyledPaper>
  );
};

export default TopBlock;

TopBlock.propTypes = {
  goalIcon: PropTypes.string.isRequired,
  goalName: PropTypes.string.isRequired,
  className: PropTypes.string
};

TopBlock.defaultProps = {
  className: ''
};
